import { render, staticRenderFns } from "./pages2C.vue?vue&type=template&id=b6b7962c&scoped=true&"
import script from "./pages2C.vue?vue&type=script&lang=js&"
export * from "./pages2C.vue?vue&type=script&lang=js&"
import style0 from "./pages2C.vue?vue&type=style&index=0&id=b6b7962c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b7962c",
  null
  
)

export default component.exports